import React, { useState, useEffect } from 'react'
import SearchBar from '../../common/components/search/SearchBar'
import { Box } from '@mui/system'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import TableHead from '@mui/material/TableHead'

import moment from 'moment'
import 'moment/locale/pt-br'

import secureLocalStorage from 'react-secure-storage'

import EventsService from '../../services/EventsService'

import Banner from '../../common/components/banner'
import event_banner from '../../assets/images/banners/event_first_page_banner.png'

import { useDefaultStyles } from '../../common/styles/default'

import MyEventStatus from './MyEventStatus'
import { getEventTypeName } from '../../events/utils/eventTypes'

export default function List() {
  const navigate = useNavigate()

  const { t } = useTranslation()
  const styles = useDefaultStyles()

  const goToEvent = (id: any) => {
    navigate(`/myevents/view/${id}`)
  }

  const [events, setEvents] = useState([] as any)
  const [displayedEvents, setDisplayedEvents] = useState([] as any)
  const [searchLoading, setSearchLoading] = useState(false)

  const user_id = secureLocalStorage.getItem('id')

  const loadEvent = async (evaluated_id: any) => {
    await EventsService.getEventsByEvaluated(evaluated_id)
      .then((response: any) => {
        if (response.status !== 400) {
          setEvents(response.data)
          setDisplayedEvents(response.data)
        }
      })
      .catch((e: Error) => {})
  }

  const normalize = (s: string) =>
    (s || '')
      .toString()
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')

  const handleSearch = (query: string | { q: string; filters?: Record<string, string | number> }) => {
    setSearchLoading(true)
    try {
      const raw = typeof query === 'string' ? query : (query && (query as any).q) || ''
      const q = normalize(raw)

      if (!q) {
        setDisplayedEvents(events)
        return
      }

      const filtered = (events || []).filter((e: any) => {
        const name = normalize(e.name || '')
        const date = normalize(moment(e.date).locale('pt-br').format('DD/MM/YYYY') || '')
        const typeName = normalize(getEventTypeName(e.type, t) || '')
        return name.indexOf(q) > -1 || date.indexOf(q) > -1 || typeName.indexOf(q) > -1
      })

      setDisplayedEvents(filtered)
    } finally {
      // small delay to show search button state when debounce is fast
      setTimeout(() => setSearchLoading(false), 150)
    }
  }

  useEffect(() => {
    loadEvent(user_id)
  }, [])

  return (
    <Box>
      <Banner
        type="medium"
        image={event_banner}
        title={t('banner_title_event')}
        subtitle={t('banner_subtitle_event_list')}
      />
      <Box className={styles.containerForm}>
        <SearchBar
          onSearch={handleSearch}
          placeholderKey="search_placeholder"
          loading={searchLoading}
        />
        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table sx={{ minWidth: 600 }} aria-label="custom pagination table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', fontSize: 20 }}>
                  {t('subtitle_table_event_name')}
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: 20 }}>
                  {t('input_label_event_type')}
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: 20 }}>
                  {t('lbl_status_event_schedule')}
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: 20 }}>
                  {t('subtitle_table_event_date')}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {displayedEvents?.map((row) => (
                <TableRow
                  key={row.id}
                  sx={{ cursor: 'pointer' }}
                  onClick={() => goToEvent(row.id)}
                >
                  <TableCell component="th" scope="row">
                    {row.name}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {getEventTypeName(row.type, t)}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <MyEventStatus status={row.status} plainText={true} />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {moment(row.date).locale('pt-br').format('DD/MM/YYYY')}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  )
}
